import { useMatchMedia } from '@betterment/js-runtime';
import { Box } from '@betterment/samba-react';

type SpendingPowerChartProps = {
  projectedMonthlySpendingAmountCents: number;
  targetMonthlySpendingAmountCents: number;
};

export const SpendingPowerChart: React.FC<SpendingPowerChartProps> = ({
  projectedMonthlySpendingAmountCents,
  targetMonthlySpendingAmountCents,
}) => {
  const isLargeScreen = useMatchMedia('atLeastMedium');

  const max = Math.max(projectedMonthlySpendingAmountCents, targetMonthlySpendingAmountCents);
  const projectedHeight = Math.round((projectedMonthlySpendingAmountCents / max) * 100);
  const targetHeight = Math.round((targetMonthlySpendingAmountCents / max) * 100);

  if (isLargeScreen) {
    return (
      <Box css={{ display: 'flex', height: '120px' }}>
        <svg width="124px" height="120px">
          <defs>
            <clipPath id="round-corner-projection">
              <rect
                x="24"
                y={`${100 - projectedHeight + 2}%`}
                width="32"
                height={`${projectedHeight}%`}
                rx="4"
                ry="4"
              />
            </clipPath>
          </defs>
          <defs>
            <clipPath id="round-corner-target">
              <rect x="68" y={`${100 - targetHeight + 2}%`} width="32" height={`${targetHeight}%`} rx="4" ry="4" />
            </clipPath>
          </defs>
          <rect
            fill="#1D6AE5"
            height={`${projectedHeight}%`}
            width="32"
            x="24"
            y={`${100 - projectedHeight}%`}
            clipPath="url(#round-corner-projection)"
          />
          <rect
            fill="#000B50"
            height={`${targetHeight}%`}
            width="32"
            x="68"
            y={`${100 - targetHeight}%`}
            clipPath="url(#round-corner-target)"
          />
          <rect width="124" height="1" fill="#212121" y="119" />
        </svg>
      </Box>
    );
  }

  return (
    <svg width="100%" height="52px">
      <defs>
        <clipPath id="round-corner-projection">
          <rect x="-1" y="8" width={`${projectedHeight}%`} height="16" rx="4" ry="4" />
        </clipPath>
      </defs>
      <defs>
        <clipPath id="round-corner-target">
          <rect x="-1" y="28" width={`${targetHeight}%`} height="16" rx="4" ry="4" />
        </clipPath>
      </defs>
      <rect fill="#1D6AE5" width={`${projectedHeight}%`} height="16" y="8" clipPath="url(#round-corner-projection)" />
      <rect fill="#000B50" width={`${targetHeight}%`} height="16" y="28" clipPath="url(#round-corner-target)" />
      <rect width="1" height="52" transform="matrix(-1 0 0 1 1 0)" fill="#212121" />
    </svg>
  );
};
